import { IpaType } from "../phonemes/ipa";
import { Rule } from "../rules/rule";
import { TransmogrificationResults } from "./transmogrificationResults";

/**
 * Create rules that map sourceSegments to targetSegments based on
 * the allophones of phoneme segments derived from Phoible data.
 * PRO: based on how common alternative phoneme segments are across languages.
 * CON: allophones are often context-sensitive (e.g., between vowels), which this ignores.
 * @param sourceSegments phoneme segments supported by input to rules
 * @param targetSegments phoneme segments allowed in output of rules
 * @param segmentToAllophones map from phoneme segments to all allophones to consider
 * @returns rules mapping source to target, segments they have in common, & segments that weren't handled
 */
export function rulesFromAllophones(
  sourceSegments: IpaType[],
  targetSegments: IpaType[],
  segmentToAllophones: Record<string, string>
): TransmogrificationResults {
  const rules: Rule[] = [];
  const common: IpaType[] = [];
  const unhandled: IpaType[] = [];

  for (const segment of sourceSegments) {
    let found = false;

    // 1st check if target supports source
    if (targetSegments.includes(segment)) {
      common.push(segment);
      found = true;
    }

    // 2nd check if target supports any of the allophones
    if (!found) {
      const options = segmentToAllophones[segment];
      if (options) {
        const allophones = options.split(' ');
        for (const allophone of allophones) {
          if (targetSegments.includes(allophone)) {
            rules.push({ from: segment, to: allophone });
            found = true;
            break;
          }
        }
      }
    }

    if (!found) {
      unhandled.push(segment);
    }
  }

  return { rules, common, unhandled };
}
